// extracted by mini-css-extract-plugin
export default {"rating":"kw-z","numberOfStars":"lw-z","count":"mw-z","barGraphSpacing":"nw-z","barGraph":"ow-z"};